import { isEmpty } from 'lodash-es'
import { usePageProps, withLayouts } from 'react-dx'
import { useLingui } from '@lingui/react/macro'

import HubPagination from '../HubPagination'
import Sidebar from '../Sidebar'

import type { getArticleCategoriesData } from '../../_service/hub'
import type { NextPage } from 'next'

import DefaultLayout from '@/pages/tad.ai/_layout'
import RootLayout from '@/pages/tad.ai/_layout/layouts/RootLayout'
import AntdLayout from '@/pages/tad.ai/_layout/layouts/AntdLayout'
import SiteSpecificContextLayout from '@/pages/tad.ai/_layout/layouts/SiteSpecificContextLayout'


import { cls } from 'tagged-classnames-free';
import Link from '@/components/Link';
interface IHubPageProps {
  pageData: Awaited<ReturnType<typeof getArticleCategoriesData>>
}
export const HubPageTemplate: NextPage<IHubPageProps> = (props) => {
  const { pageData } = props
  const paginationData = pageData.currentCategoryArticlesData?.meta.pagination

  const { t } = useLingui()

  const defaultMeta = {
    title: t`Resource Hub | Tad`,
    h1: t`Resource Hub`,
    description: t`Immerse yourself in our comprehensive collection of articles, guides, and insights about AI music generators and more.`,
    url: '/hub',
  }

  const metaData = isEmpty(pageData.meta)
    ? defaultMeta
    : (pageData.meta as typeof defaultMeta)

  return (
    <div className='pt-16 lg:pt-[92px]'>
      <h1 className='relative z-[1] pb-4 ps-0 text-center text-3xl font-bold md:pb-7 md:ps-[256px] lg:pb-12 lg:text-6xl'>
        {metaData.h1}
      </h1>
      <div
        className={cls`
          relative z-[1] mx-auto flex max-w-full 
          flex-col-reverse gap-8 px-4 pb-[50px] pt-12 
          md:flex-row md:pt-3 lg:max-w-[1048px] lg:pt-8
        `}
      >
        <Sidebar
          data={pageData.articleCategoriesData}
          currentCategoryUrl={pageData.currentCategoryUrl}
        />
        <div className='w-full flex-1 xl:w-[760px]'>
          {pageData.currentCategoryArticlesData.data.map((item) => {
            return (
              <div
                key={item.h1}
                className='border-f-border group mt-5 flex items-start gap-4 border-t pt-5 first:mt-0 md:mt-8 md:pt-8'
              >
                <span className='i-cus--tad-volume-icon group-hover:text-f-primary h-8 w-5'></span>
                <div className='flex-1'>
                  <h2 className='group-hover:text-f-primary text-lg font-semibold lg:text-xl'>
                    <Link href={item.url}>{item.h1}</Link>
                  </h2>
                  <p className='mt-2 text-sm text-white text-opacity-75 md:text-base lg:mt-3'>
                    {item.description}
                  </p>
                </div>
              </div>
            )
          })}
          {paginationData && (
            <HubPagination
              current={paginationData.page}
              size={paginationData.pageSize}
              total={paginationData.total}
              hideOnSinglePage
              getHref={(page) => {
                if (page === 1) {
                  return pageData.currentCategoryUrl
                }
                return `${pageData.currentCategoryUrl}/${page}`
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const LayoutsPage = withLayouts(HubPageTemplate, [
  (props) => {
    return (
      <DefaultLayout
        {...props}
        minHScreen
        main={{
          className: cls`bg-f-bg-base`,
        }}
        locales={[]}
      />
    )
  },
  (props) => {
    const { pageData } = usePageProps<IHubPageProps>()
    const { t } = useLingui()

    const defaultMeta = {
      title: t`Resource Hub | Tad AI`,
      h1: t`Resource Hub`,
      description: t`Immerse yourself in our comprehensive collection of articles, guides, and insights about AI music generators and more.`,
      url: '/hub',
    }
    const metaData = isEmpty(pageData.meta)
      ? defaultMeta
      : (pageData.meta as typeof defaultMeta)
    return (
      <RootLayout
        {...props}
        locales={[]}
        seo={{
          title: metaData.title,
          description: metaData.description,
        }}
      />
    )
  },
  (props) => {
    return <SiteSpecificContextLayout {...props} />
  },
  AntdLayout,
])
export default LayoutsPage
